import React from "react";
import "../../sidebar/HomeScreenSidebar.css";
import { getApiUrl } from "../../../service/network/UrlMapper";

const SmartAssistant = () => {
  return (
    <div className="iframeContainer">
      <iframe
        src={getApiUrl()["smart_assistant_url"]}
        title="Patient"
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "93vh",
        }}
      />
    </div>
  );
};

export default SmartAssistant;
